module.exports = __webpack_public_path__ + "static/media/coinbase-wallet-logo.2784f954.svg";